export default __webpack_public_path__ + "static/media/img-button-Consumer.420dc935.svg";